// Table header column styles
export const tableHeaderColumnStyles = {
  fontSize: "12px",
  letterSpacing: "0.6px",
  color: "rgb(107 114 128)",
};

// Actions header column styles
export const actionsHeaderColumnStyles = {
  ...tableHeaderColumnStyles,
  textAlign: "left" as const,
};